import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
const NAV_LINKS = [{
  label: 'Sign Up',
  to: '/apply-now'
}, {
  label: 'Dispatch',
  to: '/dispatch-services'
}, {
  label: 'Back Office',
  to: '/compliance-back-office-support'
}, {
  label: 'Lease On',
  to: '/lease-on-with-fsg'
}, {
  label: 'FAQ',
  to: '/faq'
}, {
  label: 'Contact',
  to: '/contact'
}];
export function Footer() {
  return <footer className="bg-black text-off-white pt-20 pb-24 lg:pb-10 border-t border-white/10" data-id="element-203">
      <div className="container-custom" data-id="element-204">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-16" data-id="element-205">
          {/* Brand */}
          <div className="lg:col-span-2" data-id="element-206">
            <Link to="/" className="inline-flex items-center gap-2 mb-6" data-id="element-207">
              <img src="https://images.squarespace-cdn.com/content/v1/6983a647318f183e844ca503/e2a2c4ee-2ab0-4982-9580-c994819db0b2/FSGTrans%2BTrans.png" alt="FSG Transport" className="h-auto w-auto max-h-[56px] object-contain" data-id="element-208" />
            </Link>
            <p className="text-off-white/70 text-lg max-w-md font-medium leading-relaxed" data-id="element-209">
              U.S.-based truck dispatch, load planning, broker setup, paperwork,
              billing, and back-office support for owner-operators and small
              fleets.
            </p>
          </div>

          {/* Links */}
          <div data-id="element-210">
            <h4 className="text-white font-bold uppercase tracking-widest text-sm mb-6 font-['Barlow']" data-id="element-211">
              Navigation
            </h4>
            <ul className="space-y-3" data-id="element-212">
              {NAV_LINKS.map(link => <li key={link.label} data-id="element-213">
                  <Link to={link.to} className="text-off-white/70 hover:text-white transition-colors text-sm font-medium" data-id="element-214">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-215">
            <h4 className="text-white font-bold uppercase tracking-widest text-sm mb-6 font-['Barlow']" data-id="element-216">
              Contact
            </h4>
            <ul className="space-y-4" data-id="element-217">
              <li data-id="element-218">
                <a href="tel:2346028424" className="flex items-start gap-3 text-off-white/70 hover:text-white transition-colors text-sm" data-id="element-219">
                  <Phone className="w-5 h-5 shrink-0 text-red" data-id="element-220" />
                  <span className="font-medium mt-0.5" data-id="element-221">234-602-8424</span>
                </a>
              </li>
              <li data-id="element-222">
                <a href="mailto:Dispatch@FSGTransport.com" className="flex items-start gap-3 text-off-white/70 hover:text-white transition-colors text-sm" data-id="element-223">
                  <Mail className="w-5 h-5 shrink-0 text-red" data-id="element-224" />
                  <span className="font-medium mt-0.5" data-id="element-225">
                    Dispatch@FSGTransport.com
                  </span>
                </a>
              </li>
              <li className="flex items-start gap-3 text-off-white/70 text-sm" data-id="element-226">
                <MapPin className="w-5 h-5 shrink-0 text-red" data-id="element-227" />
                <span className="font-medium mt-0.5" data-id="element-228">
                  P.O. Box 366
                  <br data-id="element-229" />
                  Hudson, OH 44236
                </span>
              </li>
              <li className="flex items-start gap-3 text-off-white/70 text-sm" data-id="element-230">
                <Clock className="w-5 h-5 shrink-0 text-red" data-id="element-231" />
                <span className="font-medium mt-0.5" data-id="element-232">
                  Sales Hours:
                  <br data-id="element-233" />
                  Mon–Fri, 9:00 AM–5:00 PM EST
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-234">
          <p className="text-off-white/50 text-sm font-medium" data-id="element-235">
            &copy; {new Date().getFullYear()} FSG Transport. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>;
}